/**
 * Easier api calls
 */
// Seperate api domain in development. Server is unified when running in production
let apiDomain = ''
if (import.meta.env.DEV) {
  apiDomain = import.meta.env.VITE_API_DOMAIN
}
if (import.meta.env.SSR) {
  apiDomain = import.meta.env.VITE_SERVER_API_DOMAIN
}

/**
 * Fetch products by category
 * @param {string} productCategory - e.g. 'office-printers', 'multifunctional-printers', 'plotters', 'finishers' 'scanners'
 *  - This matches the productCategory in the product table.
 * @param {object} [options] - Optional configuration object
 * @param {string} [options.category] - e.g. 'a4-colour', 'a3-colour', 'a4-black-and-white', 'a3-black-and-white'
 * @param {number} [options.limit=10]
 * @param {number} [options.offset=0]
 * @returns {Promise<Array<Object>>}
 */
export async function getProductByCategory(productCategory, options = {}) {
  const {
    category,
    limit, // Default values here
    offset,
  } = options
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }

  let url = `${apiDomain}/api/products/category/${productCategory}`

  if (category) {
    url += `/${category}`
  }

  try {
    const response = await fetch(`${url}${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getMultifunctionalPrinters(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }

  try {
    const response = await fetch(`${apiDomain}/api/printers/multifunctionals${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
// Printer api calls
export async function getTestMultifunctionalPrinters(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }

  try {
    const response = await fetch(
      `${apiDomain}/api/products/category/multifunctional-printers${query}`
    )
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getOfficePrinters(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/printers/officeprinters${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getProductionPrinters(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/printers/productionprinters${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getPlotterPrinters(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/printers/plotterprinters${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getAllPrinters(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/printers/all${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}

// Scanner api calls
export async function getPersonalScanners(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/scanners/personal${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getDepartmentalScanners(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/scanners/departmental${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getProductionScanners(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/scanners/production${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getDesktopWorkgroupScanners(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/scanners/desktop-workgroup${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
export async function getAllScanners(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/scanners/all${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function getFeaturedPrinters(limit, offset) {
  let query = ''
  if (limit) {
    query += `?limit=${limit}`
  }
  if (offset) {
    query += `${query ? '&' : '?'}offset=${offset}`
  }
  try {
    const response = await fetch(`${apiDomain}/api/featured-printers${query}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function getSingleProduct(modelId) {
  try {
    const response = await fetch(`${apiDomain}/api/v3/products/${modelId}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
// export async function getSingleProduct(modelId) {
//   try {
//     const response = await fetch(`${apiDomain}/api/printers/getsingleprinter/${modelId}`)
//     return response.json()
//   } catch (error) {
//     console.error(error)
//     throw error
//   }
// }

export async function getSingleScanner(modelId) {
  try {
    const response = await fetch(`${apiDomain}/api/scanners/getsinglescanner/${modelId}`)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}

export async function getSimiliarPrinters(modelId) {
  try {
    const response = await fetch(`${apiDomain}/api/printers/similiar?id=` + modelId)
    return response.json()
  } catch (error) {
    console.error(error)
    throw error
  }
}
